<template>
  <div>
    <v-navigation-drawer
      class="elevation-5"
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
      left
    >
      <!--  -->
      <template>
        <v-container class="ml-6 mt-10">
          <v-layout row wrap justify-start align-start>
            <v-flex xs11 lg11>
              <h5>คู่มือการใช้งาน API</h5>
            </v-flex>
            <v-flex xs11 lg11 mb-10>
              <v-btn
                v-for="(item, i) in TextPath"
                :key="i"
                :color="$route.path !== item.path ? 'black' : 'grey'"
                text
                :to="item.path"
                ><v-icon left dark :disabled="$route.path !== item.path">
                  mdi-chevron-double-right
                </v-icon>
                {{ item.nameAPI }}
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout row wrap justify-start align-start>
            <v-flex xs11 lg11>
              <h5>คู่มือการใช้งาน API Webscript</h5>
            </v-flex>
            <v-flex xs11 lg11 mb-10>
              <v-btn
                v-for="(item, i) in TextPath2"
                :key="i"
                :color="$route.path !== item.path ? 'black' : 'grey'"
                text
                :to="item.path"
                ><v-icon left dark :disabled="$route.path !== item.path">
                  mdi-chevron-double-right
                </v-icon>
                {{ item.nameAPI }}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </template>
    </v-navigation-drawer>

    <v-app-bar app :clipped-left="$vuetify.breakpoint.lgAndUp" color="#077893">
      <v-app-bar-nav-icon dark @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title class="ml-0 pa-0 mt-3">
        <!-- <img :src="require('@/assets/img/logoCMPWhite.png')" max-width="100" /> -->
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-title class="ml-0 pa-0 mt-0">
        <div>
          <!-- <img
            :aspect-ratio="16 / 9"
            style="border-radius: 50%"
            src="https://uatchat-develop.one.th/static/img/robot/developer1.png"
            width="40"
          /> -->
          <center>
            <v-avatar size="50" color="#ddf7ff">
              <!-- <v-icon size="30" color="black"
                >mdi-account-settings-outline</v-icon
              > -->
              <b style="font-size: 1.8rem; color: #077893">{{
                Username.slice(0, 1).toUpperCase()
              }}</b>
            </v-avatar>
          </center>
        </div>
      </v-toolbar-title>
      <v-toolbar-title class="ml-0 pa-0 mt-3">
        <div class="white--text" style="text-indent: 0.5rem">
          <h4 class="mb-2" v-if="Username.length > 9">
            {{ Username.slice(0, 9) }}
          </h4>
          <h4 class="mb-2" v-else>{{ Username }}</h4>
        </div>
      </v-toolbar-title>
      <!-- <v-layout row no-wrap justify-end align-end class="white--text">
        <v-flex xs6 lg6 class="text-end">
          <v-img :aspect-ratio="16/1"
            src="https://uatchat-develop.one.th/static/img/robot/developer1.png"
          ></v-img>
        </v-flex>
        <v-flex xs6 lg6 class="text-end">
          <h3>Suradet</h3>
        </v-flex>
      </v-layout> -->
    </v-app-bar>
  </div>
</template>

<script>
export default {
  data: () => ({
    drawer: null,
    TextPath: [
      {
        nameAPI: "API Get Consent",
        path: "/document-service-index",
      },
      {
        nameAPI: "API Send Consent",
        path: "/document-service-2",
      },
      {
        nameAPI: "API Get Consent...",
        path: "/document-service-3",
      },
    ],
    TextPath2: [
      {
        nameAPI: "API Get Status...",
        path: "/document-service-webscript",
      },
    ],
  }),
  computed: {
    Username: {
      get() {
        return this.$cookies.get("OneUsername") || "-";
      },
    },
  },
  mounted() {},
  methods: {},
};
</script>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}
</style>

<style>
.theme--light.v-btn--active:hover::before,
.theme--light.v-btn--active::before {
  opacity: 0 !important;
}
</style>
